import React from 'react';
import logos from 'config/logos';
import { LANGUAGES } from 'config/types/prop';

const Logo = ({ currentEdition, ...props }) => (
  <img
    alt="Babbel Logo"
    src={logos[`${currentEdition}`]}
    height="30"
    width="195"
    {...props}
  />
);

Logo.propTypes = {
  currentEdition: LANGUAGES.isRequired,
};

export default Logo;
